import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Input from '@jetbrains/ring-ui/components/input/input';
import classNames from 'classnames';
import styles from './floating-label-input.css';
export function FloatingLabelInput(props) {
    const { className, value, floatingLabel, ...rest } = props;
    const ref = useRef(null);
    const [refStyles, setRefStyles] = useState();
    useEffect(() => {
        const refStyles = ref.current && window.getComputedStyle(ref.current);
        if (refStyles) {
            setRefStyles(refStyles);
        }
    }, []);
    return (_jsx(Input, { ...Input.defaultProps, className: classNames(styles.wrapper, className), inputRef: ref, value: value, afterInput: floatingLabel && (_jsxs("div", { style: refStyles ? toCssProperties(refStyles) : undefined, className: styles.floatingLabelWrapper, children: [_jsx("span", { className: styles.textInvisibleBoundary, children: value }), _jsx("span", { className: styles.floatingLabel, children: floatingLabel })] })), ...rest }));
}
// as we don't need every css-property, just grab only ones which can affect text position and width
function toCssProperties(styles) {
    const { paddingTop, paddingBottom, fontSize, paddingLeft, paddingRight, borderWidth } = styles;
    return { paddingTop, paddingBottom, fontSize, paddingLeft, paddingRight, borderWidth };
}
